import React, { useEffect } from 'react';
import redirectingImage from '../static/images/redirecting.gif';
import { useNavigate } from 'react-router-dom';

const UnlockResponse: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Append "Successfully" to the message
    const msgTag = document.getElementById("msgTag");
    if (msgTag) {
      msgTag.textContent += " Successfully";
    }
  
    // Handle redirect URL
    const params = new URLSearchParams(window.location.search);
    let redirectUrl = params.get("target_url");
  
    if (redirectUrl) {
      redirectUrl = decodeURIComponent(decodeURIComponent(redirectUrl));
    } else {
      // fallback URL if redirect param not present
      setTimeout(()=>{
        navigate('/');
      },3000) 
    }
  
    // Create or update the meta refresh tag
    let metaTag = document.querySelector('meta[http-equiv="refresh"]');
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("http-equiv", "refresh");
      document.head.appendChild(metaTag);
    }
  
    metaTag.setAttribute("content", `5;url=${redirectUrl}`);
  }, [navigate]);

  return (
    <div className="container">
      <div className="inner-wrapper">
        <div className="row">
          <div 
            className="col-md-5 col-sm-8 form-container login"
            style={{ 
              background: 'transparent',
              border: '1px solid transparent'
            }}
          >
            <header className="form-header clearfix">
              <h2 className="heading pull-left">Your account has been unlocked.</h2>
              <span className="loadingSpinner">
                <img src={redirectingImage} alt="Redirecting" />
              </span>
            </header>
            
            <div className="content row">
              <div>
                <p>Redirecting to WaveMaker Home</p>
              </div>
            </div>

            <footer 
              className="form-footer row" 
              style={{ borderTop: '1px solid #141B2B' }}
            >
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnlockResponse; 